import React from "react"
import types from "prop-types"
import { SidebarVisibilityControl } from "shared/Sidebar"

const RecipientsHeader = ({ hiddenSidebar, toggleSidebar }) => (
  <div className="relative mb-8">
    <SidebarVisibilityControl
      hiddenSidebar={hiddenSidebar}
      toggleSidebar={toggleSidebar}
    />
    <h1 className="header-title tracking-tight absolute-horizontal-center top-0 my-0 -ml-6">
      Survey Recipients
    </h1>
  </div>
)

RecipientsHeader.propTypes = {
  hiddenSidebar: types.bool.isRequired,
  toggleSidebar: types.func.isRequired,
}

export default RecipientsHeader
